import { ReactElement, ReactNode } from 'react';

import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { SxProps } from '@mui/material';

export interface IGroupPanelProps {
    scrollId?:string,
    title: string,
    children?: ReactNode | ReactElement,
    noBoderTop?: boolean,
    noBoderBottom?: boolean,
    sx?:SxProps
}

export default function GroupPanel({scrollId = 'GroupPanelScroll', title, children, noBoderTop = true, noBoderBottom = true, sx, ...rest }: IGroupPanelProps) {
    return (
        <Stack height={'100%'} border={'1px solid'} borderColor={'divider'} sx={sx}>
            <Box px={3} py={2} border={'1px solid'} borderColor={'divider'} borderTop={0} borderBottom={0} {...(noBoderTop && { borderTop: 0 })}>
                <Typography color={'primary.main'} variant='headline1' fontWeight={400}>{title}</Typography>
            </Box>
            <Stack id={scrollId} component={'ul'} height={'100%'} margin={0} padding={0} border={'1px solid'} flex={1} borderColor={'divider'}  {...(noBoderBottom && { borderBottom: 0 })} overflow={'auto'}>
                {children}
            </Stack>
        </Stack>
    );
}
